import { sessionStorageKeyConstants } from '../../constants/session-storage-key-constants'
import { getHeaders } from '../axios/axios-helpers'
import HttpClient from '../axios/http-client'

export async function createOrderDocumentType(request) {
  const apiPath = '/documentType'
  const idToken = sessionStorage.getItem(sessionStorageKeyConstants.ID_TOKEN)
  const headers = getHeaders(idToken)
  const httpClient = new HttpClient(headers)
  return httpClient.documentInstance().post(apiPath, null, {
    params: { type: request },
  })
}
